import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  httpClient = inject(HttpClient);

  constructor() {}

  getReports(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/reports').pipe(
      catchError((error) => {
        console.error('Error fetching reports:', error);
        return of(error);
      }),
    );
  }

  getPreSignedUrl(reportId: string, type: 'view' | 'download') {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/restaurants/reports/' + reportId + '/' + type)
      .pipe(
        catchError((error) => {
          console.error('Error fetching pre-signed url:', error);
          return of(error);
        }),
      );
  }
}
